// How long should the ApiService wait before abandoning a request?
export const API_SERVICE_TIMEOUT = 20000;

// These are the headers all request start with.
export const API_SERVICE_DEFAULT_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
};
